'use client';

import * as RadixSelect from '@radix-ui/react-select';
import clsx from 'clsx';
import { ChevronDownIcon } from '@/assets/react-icons/ChevronDownIcon';
import { ScrollArea } from '@/components/ScrollArea';
import { Text } from '../Text';
import styles from './Select.module.scss';
type Props = {
  className?: string;
  disabled?: boolean;
  disabledOptions?: boolean;
  error?: {
    message?: string;
  };
  itemClassname?: string;
  onScroll?: (event: React.UIEvent<HTMLDivElement, UIEvent>) => void;
  options: {
    label: string;
    value: string;
  }[];
  placeholder?: string;
  viewPortClassName?: string;
  viewportRef?: React.RefObject<HTMLDivElement>;
} & RadixSelect.SelectProps;
export const Select = ({
  className,
  disabled,
  disabledOptions,
  error,
  itemClassname,
  onScroll,
  options,
  placeholder,
  required,
  value = '',
  viewPortClassName,
  viewportRef,
  ...rootProps
}: Props) => {
  return <div className={clsx(styles.wrapper, disabled && styles.disabled, className, error && styles.hasError)} data-sentry-component="Select" data-sentry-source-file="Select.tsx">
      <RadixSelect.Root value={value} {...rootProps} disabled={disabled} required={required} data-sentry-element="unknown" data-sentry-source-file="Select.tsx">
        <RadixSelect.Trigger aria-label={placeholder} className={clsx(styles.wrapper__trigger, value && styles.isSelected, placeholder && styles.withPlaceholder)} data-sentry-element="unknown" data-sentry-source-file="Select.tsx">
          {placeholder && <span className={styles.wrapper__placeholder}>{placeholder}</span>}
          <RadixSelect.Value className={styles.wrapper__value} data-sentry-element="unknown" data-sentry-source-file="Select.tsx" />
          <ChevronDownIcon className={styles.wrapper__dropdownIcon} data-sentry-element="ChevronDownIcon" data-sentry-source-file="Select.tsx" />
        </RadixSelect.Trigger>
        <RadixSelect.Content className={styles.content} position='popper' data-sentry-element="unknown" data-sentry-source-file="Select.tsx">
          <ScrollArea className={styles.scrollArea} onScroll={onScroll} viewPortClassName={clsx(styles.content__viewport, viewPortClassName)} data-sentry-element="ScrollArea" data-sentry-source-file="Select.tsx">
            <RadixSelect.Viewport className={styles.list} ref={viewportRef} data-sentry-element="unknown" data-sentry-source-file="Select.tsx">
              {options.map(({
              label,
              value
            }) => <RadixSelect.Item className={clsx(styles.list__item, itemClassname)} disabled={disabledOptions} key={value} value={value}>
                  <RadixSelect.ItemText>{label}</RadixSelect.ItemText>
                </RadixSelect.Item>)}
            </RadixSelect.Viewport>
          </ScrollArea>
        </RadixSelect.Content>
        {required && <Text className={styles.requiredAsterisk} color='red' tag='span' type='field_text'>
            *
          </Text>}
      </RadixSelect.Root>
      {error?.message && <span className={styles.errorMessage}>{error.message}</span>}
    </div>;
};